import { Link } from "react-router-dom";

export default function ProductCard({ product }) {
  const discount = product.compare_at_price && product.compare_at_price > product.price
    ? Math.round(((product.compare_at_price - product.price) / product.compare_at_price) * 100)
    : 0;

  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group block bg-white rounded-2xl border border-oshveda-borderSubtle hover:border-oshveda-borderStrong transition-all duration-300 overflow-hidden"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-oshveda-bgAlt">
        <img
          src={product.image_url}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
          loading="lazy"
        />
        {discount > 0 && (
          <span className="absolute top-3 left-3 bg-oshveda-accent text-white text-[10px] tracking-widest uppercase px-3 py-1 rounded-full">
            {discount}% Off
          </span>
        )}
        {product.featured && (
          <span className="absolute top-3 right-3 bg-oshveda-primary text-oshveda-bg text-[10px] tracking-widest uppercase px-3 py-1 rounded-full">
            Bestseller
          </span>
        )}
      </div>
      <div className="p-5">
        <div className="label-eyebrow mb-1">{product.category}</div>
        <h3 className="font-serif text-xl text-oshveda-ink leading-tight mb-2 group-hover:text-oshveda-accent transition-colors">
          {product.name}
        </h3>
        <p className="text-sm text-oshveda-ink2 line-clamp-2 mb-3">{product.short_description}</p>
        <div className="flex items-baseline gap-2">
          <span className="font-serif text-2xl text-oshveda-primary">₹{product.price.toFixed(0)}</span>
          {product.compare_at_price > product.price && (
            <span className="text-sm text-oshveda-muted line-through">₹{product.compare_at_price.toFixed(0)}</span>
          )}
        </div>
      </div>
    </Link>
  );
}
